module.exports = __webpack_public_path__ + "static/media/EricAsagba.64406152.jpg";